<template>
    <div>
        <div>
            Daten aus vorherigen Mietanträgen übernehmen
        </div>
        <ListView
            :style="{ width: '85%' }"
            :data-items="dataItems.slice(skip, skip + take)"
            :item="'myItem'"
            :header="'myHeader'"
            :footer="'myFooter'"
        >
            <template v-slot:myItem="{ props }">
                <Card
                    :style="{
          padding: '20px 24px',
          border: 'none',
          borderBottom: '1px solid rgba(0,0,0,0.12)',
        }"
                    :orientation="'horizontal'"
                    class="d-flex justify-content-between"
                >
                    <div class="k-vbox k-column">
                        <div :style="{ padding: '0 8px', marginRight: '3rem' }">
                            <CardTitle :style="{ fontSize: '18px' }">{{ props.dataItem.request_number }}</CardTitle>
                            <CardSubtitle :style="{ fontSize: '14px', marginTop: '0px' }">Beschreibung: {{ props.dataItem.desc }}</CardSubtitle>
                            <CardSubtitle :style="{ fontSize: '14px', marginTop: '0px' }">Mietempfänger: {{ props.dataItem.customer.email }}</CardSubtitle>
                            <CardSubtitle :style="{ fontSize: '12px' }">Zeitraum: {{ props.dataItem.from | moment }} bis {{ props.dataItem.until | moment }}</CardSubtitle>

                        </div>
                        <CardActions :style="{ padding: '0px' }">
                            <button class="btn btn-primary">
                                Alle Daten übernehmen
                            </button>
                            <button class="btn btn-secondary">
                                Nur das Equipment übernehmen
                            </button>
                            <!--
                            <KButton :rounded="'medium'" :fill-mode="'flat'" :size="'medium'">
                                Daten für diesen Mietantrag übernehmen
                            </KButton>-->
                        </CardActions>
                    </div>
                    <!--
                    <CardImage
                        :src="`https://www.telerik.com/kendo-vue-ui/components/listview/assets/articles/${props.dataItem.Image}`"
                        :style="{ width: '220px', height: '140px', maxWidth: '220px' }"
                    />
                    -->
                </Card>
            </template>
            <template v-slot:myHeader>

                <ListViewHeader
                    :style="{ color: 'rgb(160, 160, 160)', fontSize: '14px' }"
                    class="pl-4 pb-2 pt-2 pr-4"
                >
                    Meine vorherigen Mietanträge <KInput
                        :class="'filter-input'"
                        :placeholder="'Mietanträge suchen'"
                        :input-suffix="'suffix'"
                        @input="handleFilterChange"
                    >
                        <template v-slot:suffix>
                            <span class="k-input-icon k-icon k-i-search"></span>
                        </template>
                    </KInput>

                </ListViewHeader>
            </template>
            <template v-slot:myFooter>
                <ListViewFooter
                    :style="{ color: 'rgb(160, 160, 160)', 'font-size': '14px' }"
                    class="pl-3 pb-2 pt-2"
                >
                    <!--{{ messages }} unread messages in total-->
                </ListViewFooter>
            </template>
        </ListView>
        <Pager
            :skip="skip"
            :take="take"
            @pagechange="handlePageChange"
            :total="dataItems.length"
        />
    </div>

</template>

<script>

import {
    ListView,
    ListViewFooter,
    ListViewHeader,
} from '@progress/kendo-vue-listview';
import { filterBy } from '@progress/kendo-data-query';
import { Input } from '@progress/kendo-vue-inputs';
import {
    Filter,
    Operators,
    TextFilter,
    NumericFilter,
    BooleanFilter,
} from '@progress/kendo-vue-data-tools';
import { Pager } from '@progress/kendo-vue-data-tools';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Card, CardHeader, CardBody, CardTitle, CardSubtitle, CardImage, CardActions, Avatar } from "@progress/kendo-vue-layout";

export default {
    name: "request-previous",
    components: {
        'KFilter':Filter,
        'KInput': Input,
        Card,
        CardHeader,
        CardBody,
        CardTitle,
        CardSubtitle,
        CardImage,
        CardActions,
        Avatar,
        'KButton': Button,
        Pager,
        ListView,
        ListViewFooter,
        ListViewHeader,
    },
    data() {
        return {
            filter: null,
            previousRequestsDatasource: [],
            previousRequestsDatasourceUnfiltered: [],
            pageSize: 999,
            page: 1,
            skip: 0,
            take: 3,
            contacts: [
                {
                    "id": 1,
                    "name": "Jenson Delaney",
                    "email": "jenson.delany@mail.com",
                    "messagesCount": 3
                },
                {
                    "id": 2,
                    "name": "Amaya Coffey",
                    "email": "amaya.coffey@mail.com",
                    "messagesCount": 1
                },
                {
                    "id": 3,
                    "name": "Habib Joyce",
                    "email": "habib.joyce@mail.com",
                    "messagesCount": 5
                },
                {
                    "id": 4,
                    "name": "Lilly-Ann Roche",
                    "email": "lilly-ann.roche@mail.com",
                    "messagesCount": 8
                },
                {
                    "id": 5,
                    "name": "Giulia Haworth",
                    "email": "giulia.haworth@mail.com",
                    "messagesCount": 3
                },
                {
                    "id": 6,
                    "name": "Dawson Humphrey",
                    "email": "dawson.humphrey@mail.com",
                    "messagesCount": 2
                },
                {
                    "id": 7,
                    "name": "Reilly McCullough",
                    "email": "reilly.mccullough@mail.com",
                    "messagesCount": 3
                }
            ],
            articles: [
                {
                    "Title": "How to Make Games for Everyone",
                    "Subtitle": "Why the new player’s experience matters",
                    "Date": "Jan 21,  2020",
                    "Image": "1-220x140.png"
                },
                {
                    "Title": "How to design with love?",
                    "Subtitle": "7 tips to fall in love with your job.",
                    "Date": "Feb 24,  2020",
                    "Image": "2-220x140.png"
                },
                {
                    "Title": "A good designer is an Emotional Polymath — what?",
                    "Subtitle": "Polymaths describes a person whose expertise spans a significant number of realities. ",
                    "Date": "Jan 16,  2020",
                    "Image": "3-220x140.png"
                },
                {
                    "Title": "Why Minimalist Logos Are the Best for Big Business",
                    "Subtitle": "Analyzing logos from giants like Netflix, Youtube, and Google",
                    "Date": "Feb 20, 2020",
                    "Image": "4-220x140.png"
                },
                {
                    "Title": "Money, Likes, and Memes Are All the Same Thing",
                    "Subtitle": "How the token economy has replaced cash with Twitch emotes and Instagram likes",
                    "Date": "Feb 13, 2020",
                    "Image": "5-220x140.png"
                },
                {
                    "Title": "From UX to UI development",
                    "Subtitle": "The transition between the stages of the digital design process",
                    "Date": "Jan 11, 2020",
                    "Image": "6-220x140.png"
                },
                {
                    "Title": "7 Things Mentally Strong People Avoid Doing",
                    "Subtitle": "Become your own mental strength coach",
                    "Date": "Jan 17, 2020",
                    "Image": "7-220x140.png"
                },
                {
                    "Title": "How to Solve Your 'Lack of Motivation' Problem",
                    "Subtitle": "Hint: Understand that lack of motivation is a lie.",
                    "Date": "Mar 5, 2020",
                    "Image": "8-220x140.png"
                },
                {
                    "Title": "Make it a habit to externalize your design work",
                    "Subtitle": "Move faster by revealing the process through sketches, whiteboards and by printing your work out",
                    "Date": "Feb 12, 2020",
                    "Image": "9-220x140.png"
                },
                {
                    "Title": "Morning Routines That Will Help You Feel More Energized",
                    "Subtitle": "Skip your cup of coffee and do these instead.",
                    "Date": "Feb 19, 2020",
                    "Image": "10-220x140.png"
                },
                {
                    "Title": "What Color is Your Name? A New Synesthesia Tool Will Show You",
                    "Subtitle": "Here's your chance to see how people with synesthesia perceive letters and numbers",
                    "Date": "Feb 3, 2020",
                    "Image": "11-220x140.png"
                },
                {
                    "Title": "When it comes to design, your eyes are way better than maths",
                    "Subtitle": "A quick look at how mathematics is not the ultimate source of design thruth",
                    "Date": "Feb 22, 2020",
                    "Image": "12-220x140.png"
                },
                {
                    "Title": "Microinteractions: small details matter",
                    "Subtitle": "Microinteractions are the small details that exist inside features. ",
                    "Date": "Jan 7, 2020",
                    "Image": "13-220x140.png"
                },
                {
                    "Title": "Key principles in animation",
                    "Subtitle": "Animated interfaces are full of life and emotions. Animations add life to static things.",
                    "Date": "Mar 24, 2020",
                    "Image": "14-220x140.png"
                },
                {
                    "Title": "The 60-30-10 Rule of Time Management",
                    "Subtitle": "A simple framework for allocating your time.",
                    "Date": "Mar 13, 2020",
                    "Image": "15-220x140.png"
                },
                {
                    "Title": "Real-time mobile UI/UX prototyping with Figma Mirror",
                    "Subtitle": "Today many design teams are transferring their design system from Sketch and Adobe XD to Figma.",
                    "Date": "Jan 30, 2020",
                    "Image": "16-220x140.png"
                },
                {
                    "Title": "5 apps that will turn your mobile phone into a productivity machine",
                    "Subtitle": "Instead of letting your mobile device become detrimental to your productivity, here are tips to turn your phone into a productivity machine.",
                    "Date": "Jan 9, 2020",
                    "Image": "17-220x140.png"
                },
                {
                    "Title": "Lessons I've Learned From Studying Money for 10 Years",
                    "Subtitle": "Master money, and you'll be able to do more work you enjoy and less work of the bill-paying variety.",
                    "Date": "Mar 14, 2020",
                    "Image": "18-220x140.png"
                },
                {
                    "Title": "The 5-Year Rule: How to Create the Future You Want",
                    "Subtitle": "A proven process for building your dream life",
                    "Date": "Feb 11, 2020",
                    "Image": "19-220x140.png"
                },
                {
                    "Title": "Creativity is only impressive when there's restrictions",
                    "Subtitle": "Why 'form follows function' is a valid design principle in today's web design landscape",
                    "Date": "Feb 18, 2020",
                    "Image": "20-220x140.png"
                },
                {
                    "Title": "3 areas of focus to becoming a better Product Designer",
                    "Subtitle": "Close Sketch. Stop browsing Dribbble. Forget color for a second.",
                    "Date": "Jan 23, 2020",
                    "Image": "21-220x140.png"
                },
                {
                    "Title": "The secret of usable design",
                    "Subtitle": "Improving usability through emotional, reflective and visceral design.",
                    "Date": "Feb 26, 2020",
                    "Image": "22-220x140.png"
                },
                {
                    "Title": "When You Eat Is More Important Than What You Eat",
                    "Subtitle": "A practical guide to time-restricted eating",
                    "Date": "Mar 23, 2020",
                    "Image": "23-220x140.png"
                },
                {
                    "Title": "Breaking into Design",
                    "Subtitle": "How to grow as a designer and land your first position in the field",
                    "Date": "Mar 4, 2020",
                    "Image": "24-220x140.png"
                },
                {
                    "Title": "What's the Difference Between Brand and Brand Identity",
                    "Subtitle": "Semantics and the Quest for Truth",
                    "Date": "Feb 16, 2020",
                    "Image": "25-220x140.png"
                }
            ]
        };
    },
    computed: {
        dataItems() {
            return filterBy(this.previousRequestsDatasource, this.filter);
        },
        messages() {
            return this.contacts.reduce((acc, el) => {
                acc = acc + el.messagesCount;
                return acc;
            }, 0);
        },
    },
    mounted() {
        this.init();
    },
    filters: {
        moment: function (date) {
            return moment(date).format(AshnetApp.dateTimeFormat);
        }
    },
    methods: {

        init(){
            this.loadPreviousRentalRequests();
        },
        moment: function () {
            return moment();
        },
        handleFilterChange(ev) {
            this.filter = {
                logic: 'or',
                filters: [
                    { field: 'desc', operator: 'contains', value: ev.value },
                    { field: 'number', operator: 'contains', value: ev.value },
                    { field: 'request_number', operator: 'contains', value: ev.value },
                    { field: 'customer.combinedName', operator: 'contains', value: ev.value },
                ],
            };
        },


        loadPreviousRentalRequests(){
            // Laden der Kunden und setzen eventuell gesetzter Preset IDs (neu anegelegte Kunden oder aus Vorauswahl)
            axios
                //.get('/api/requestpage?page='+this.page+'&pageSize='+this.pageSize)
                .get('/api/requestpage?page='+this.page+'&pageSize='+this.pageSize+'&sort=%5B%7B%22ascending%22%3Afalse%2C%22field%22%3A%22from%22%7D%5D')
                .then(response => {
                    this.previousRequestsDatasource = response.data.data;
                    this.previousRequestsDatasourceUnfiltered = response.data.data;
                });
        },

        handlePageChange(e) {
            this.skip = e.skip;
        },
    },
}
</script>

<style scoped>

</style>
